module.exports = __webpack_public_path__ + "img/review@2x.98be5d0.jpg";